<template>
  <section v-if="mq.mdPlus" class="countdown">
    <div v-if="mq.mdPlus" class="logo-container">
      <img src="@/assets/images/logo.svg" class="logo" />
    </div>
    <div class="container">
      <h2>Be The First To Know</h2>
      <Countdown :end="endDate" />
    </div>
  </section>
  <section v-else class="countdown-section">
    <div class="container container--narrow">
      <p>Members Early Access</p>
      <Countdown :end="endDate" />
    </div>
  </section>
  <section v-if="!mq.mdPlus">
    <Picture :images="firstImage" />
  </section>
  <section v-if="!isLoggedIn" ref="form" class="register-form">
    <div class="container">
      <div class="intro">
        <h3>
          Sign up & create a Members Only account to receive early access to the
          collection
        </h3>
        <p>
          Create an account now and you'll step into our V.I.P. world of unique
          rewards and bespoke benefits. Membership earns you early access to
          sales and new collections, vouchers, exclusive gifts and more - and
          we'll give you £20 to spend on your first order.
        </p>
        <div class="sso">
          <SingleSignOn />
        </div>
      </div>
      <div class="divider">or</div>
      <RegisterForm @success="handleRegisterSuccess" />
    </div>
  </section>
  <section>
    <Picture :images="secondImage" />
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Countdown from "@/components/landing/Countdown.vue";
import RegisterForm from "@/components/account/RegisterForm.vue";
import SingleSignOn from "@/components/SingleSignOn.vue";
import { signUpBonus } from "@/config.js";
import Picture from "@/components/Picture.vue";

export default {
  name: "LandingSS24",
  components: {
    Countdown,
    RegisterForm,
    SingleSignOn,
    Picture,
  },
  inject: ["mq"],
  data() {
    return {
      endDate: "2024-02-25T14:00",
      firstImage: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/gloria.jpg?v=1715859251",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/gloria.jpg?v=1715859251",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/gloria.jpg?v=1715859251",
      },
      secondImage: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Product_Image_4_1.jpg?v=1715859334",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Product_Image_4_1.jpg?v=1715859334",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Background_Image_1_e8c85760-c2af-4b1c-bd9b-6b0817c3ffdb.jpg?v=1715856011",
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("app", ["currencyCode"]),
    ...mapState("auth", ["multipassAccount"]),
    bonus() {
      if (!this.currencyCode) {
        return null;
      }

      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  methods: {
    handleRegisterSuccess() {
      const VWO = window.VWO || [];
      VWO.event =
        VWO.event ||
        function () {
          VWO.push(["event"].concat([].slice.call(arguments)));
        };

      VWO.event("accountSignup", {
        signup: "success",
      });

      window.location.href = this.multipassAccount.url;
    },
    scrollDownToForm() {
      this.$refs["form"].scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  @include t__editorial-headline-10;
  color: white;
  margin-bottom: 33px;

  @include respond-above(md) {
    @include t__editorial-headline-50;
  }
}

h2 {
  @include utility-body(11px);
  text-wrap: balance;
  margin-bottom: 13px;

  @include respond-above(md) {
    @include utility-body(32px);
  }
}

p {
  @include t__utility-body-10;
  margin-bottom: 5px;

  @include respond-above(md) {
    @include t__utility-body-20;
  }
}

.divider {
  position: relative;
  text-align: center;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 20px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-bottom: solid 1px #d4d4d4;
    width: 40%;
    left: 0;
  }

  &::after {
    left: auto;
    right: 0;
  }
}

.countdown-section {
  background-color: black;
  text-align: center;
  padding: 38px 0;

  @include respond-above(md) {
    padding: 68px 0;
  }

  p {
    color: white;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 10px;
  }
}

.image {
  width: 100%; //temporary
  height: auto;
}

section.intro {
  padding: 50px 0;

  @include respond-above(md) {
    text-align: center;
    padding: 58px 0;
  }

  .container {
    max-width: 830px;
  }
}

section.register-form {
  padding: 50px 0 30px;
  text-align: center;

  @include respond-above(md) {
    padding: 30px 0 50px;
  }

  .container {
    max-width: 830px;
  }

  h2 {
    margin-bottom: 30px;
  }

  .sso {
    max-width: 475px;
    margin: 0 auto;

    :deep(.sso-buttons) {
      border-bottom: none;
    }
  }

  :deep(.sso-buttons .button--medium),
  :deep(.form .button) {
    max-width: 335px;
    margin: 0 auto;
  }
}

section.media {
  position: relative;
  cursor: pointer;

  h2 {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    color: white;

    @include respond-above(md) {
      top: auto;
      bottom: 100px;
    }
  }
}

.early-access-video {
  :deep(.video__element) {
    aspect-ratio: 390/689;
  }
}

// section countdown styles

section.countdown {
  height: 110vh;
  position: relative;
  background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/footer_1.jpg?v=1715860699");
  background-position: top center;
  background-size: cover;

  :deep(.video__element) {
    object-fit: cover;
  }

  .container {
    position: absolute;
    margin: 0 auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 2;
  }

  :deep(.countdown-clock) {
    margin-bottom: 25px;
  }

  h2 {
    font-size: 16px;
    font-weight: 400;
    color: $color-white;
    font-family: $body-font-family;
    margin-bottom: 10px;

    @include respond-above(md) {
      font-size: 32px;
    }
  }
}

// register form stylings

section.register-form {
  text-align: center;
  padding: 45px 0;

  @include respond-above(md) {
    padding: 45px 0 100px;
  }

  .container {
    max-width: 830px;
  }

  .login-button__wrapper {
    padding-bottom: 35px;

    @include respond-above(md) {
      max-width: 335px;
      margin: 0 auto;
    }
  }

  .intro {
    padding: 30px 0 40px;

    @include respond-above(md) {
      padding: 50px 0;
    }

    h3 {
      margin-bottom: 60px;
      @include editorial-headline(32px);
      text-wrap: balance;

      @include respond-above(md) {
        @include editorial-headline(40px);
        margin-bottom: 80px;
      }
    }

    p {
      display: none;
      font-size: 24px;
      font-weight: 400;
      font-family: $heading-font-family;
      font-weight: 150%;
      text-wrap: pretty;
      margin-bottom: 100px;

      @include respond-above(md) {
        display: block;
      }
    }
  }

  .sso {
    :deep(.sso-buttons) {
      border-bottom: none;
      padding: 0;
      margin-bottom: 0;
      margin-left: 0;
      margin-right: 0;
    }
  }

  :deep(.form) {
    @include respond-above(md) {
      margin: 0 auto;
      max-width: 335px;
    }
  }

  :deep(.sso-buttons .button--medium) {
    @include respond-above(md) {
      max-width: 335px;
      margin: 0 auto;
    }
  }
}

.logo-container {
  bottom: 40px;
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
}

.logo {
  display: none;
  @include respond-above(md) {
    width: 90%;
    z-index: 1;
    filter: invert(1);
    display: block;
  }
}
</style>
